import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=7fe314c8&scoped=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=7fe314c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe314c8",
  null
  
)

export default component.exports